import { render, staticRenderFns } from "./interFaceConfig.vue?vue&type=template&id=04a01122&scoped=true&"
import script from "./interFaceConfig.vue?vue&type=script&lang=js&"
export * from "./interFaceConfig.vue?vue&type=script&lang=js&"
import style0 from "./interFaceConfig.vue?vue&type=style&index=0&id=04a01122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a01122",
  null
  
)

component.options.__file = "interFaceConfig.vue"
export default component.exports